import {
  AvatarImg,
  LogoMerchant,
  ProfileMerchant,
} from "@/shared/components/common/icons";
import StackKit from "@/shared/components/kit/stack";
import { useRoleStore } from "@/store/useRoleStore";
import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  useTheme,
} from "@mui/material";
import { z } from "zod";
import { useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import TypoGraphyKit from "../../kit/typoGraphy";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import axios, { AxiosError } from "axios";
import CustomButton from "../../kit/button";
import { fetchProfile } from "@/api/user/profile";
import { fetchPazirandeProfile } from "@/api/merchant/request.get";

const formSchema = z.object({
  nID: z.string().min(1, "نام کاربری الزامی است"),
  pass: z.string().min(1, "رمز عبور الزامی است"),
});
type FormData = z.infer<typeof formSchema>;

const AvatarUploader = ({ isExpanded }: { isExpanded?: any }) => {
  const [openModal, setOpenModal] = useState(false);
  const [pendingRole, setPendingRole] = useState<"user" | "merchant" | null>(null);
  const roleEnterConditional = localStorage.getItem("roleEnter");
  const theme = useTheme();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<FormData>({
    resolver: zodResolver(formSchema),
  });
  const setRole = useRoleStore((state) => state.setRole);

  const openConfirmationModal = (role: "user" | "merchant") => {
    setPendingRole(role);
    setOpenModal(true);
  };

  const confirmRoleChange = () => {
    if (pendingRole) {
      setRole(pendingRole);
      localStorage.setItem("role", pendingRole);
    }
    setOpenModal(false);
    setPendingRole(null);
  };

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const currentRole = localStorage.getItem("roleEnter") as "user" | "merchant";
  const { data } = useQuery({
    queryKey: ["profile-data", currentRole],
    queryFn: () =>
      currentRole === "merchant" ? fetchPazirandeProfile() : fetchProfile(),
  });
  const { mutate: fetchLogin, isPending } = useMutation({
    mutationFn: async (form: any) => {
      const authHeader =
        pendingRole === "user"
          ? "Basic MjBDYXJkQXBwOmU5YjUwMTM2NDFlMmQ="
          : "Basic MjBDYXJkUGF6aXJhbmRlaDpzcmY2M2diZDdKNTFEbg==";

      const response = await axios.post(`${baseURL}/sso/api/v1/login`, form, {
        headers: {
          Authorization: authHeader,
          "Content-Type": "application/json",
        },
      });

      return response.data;
    },
    
    onSuccess: (data: any) => {
      const userId = data?.data?.userId;
      const apps = data?.data?.apps;
      const role = data?.data?.roleEnter || data?.role;
      const token = `${data?.data?.Access_Token}`;
      const tokenbest = data?.data?.token_best_unify;
      const refreshToken = data?.data?.Refresh_Token;

      localStorage.setItem("userPhone", data?.data?.mobile);
      localStorage.setItem("ID", userId);
      localStorage.setItem("newrole", apps);
      pendingRole && localStorage.setItem("roleEnter", pendingRole);
      localStorage.setItem("token", token);
      localStorage.setItem("tokenbest", tokenbest);
      localStorage.setItem("refreshToken", refreshToken);

      navigate("/");
      window.location.reload();
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در ورود به سیستم");
    },
  });

  const onSubmit = async (data: FormData) => {
    fetchLogin(data);
  };
  return (
    <div className="w-[73px] flex flex-col items-center gap-3">
      {roleEnterConditional === "user" ? (
        <>
          <StackKit
            direction={"row"}
            gap={2}
            sx={{ width: "300px" }}
            justifyContent={"center"}
            alignItems={"end"}
          >
            <div
              style={{ cursor: "pointer" }}
              onClick={() => openConfirmationModal("user")}
            >
              <StackKit className="overflow-hidden bg-[#2C2B3F] rounded-full p-2 w-[50px] h-[50px] flex items-center justify-center">
                <AvatarImg />
              </StackKit>
            </div>
            {isExpanded && (
              <TypoGraphyKit variant="subtitle2" sx={{ minWidth: "130px" }}>
                {data?.first_name} {data?.last_name}
              </TypoGraphyKit>
            )}
          </StackKit>
          <StackKit
            direction={"row"}
            gap={2}
            sx={{ width: "300px" }}
            justifyContent={"center"}
            alignItems={"end"}
          >
            <div
              style={{ cursor: "pointer" }}
              onClick={() => openConfirmationModal("merchant")}
            >
              <StackKit className="overflow-hidden bg-[#2C2B3F] rounded-full p-1 w-[30px] h-[30px] flex items-center justify-center">
                <ProfileMerchant />
              </StackKit>
            </div>
            {isExpanded && (
              <TypoGraphyKit variant="subtitle2" sx={{ minWidth: "100px" }}>
                رفتن به پنل پذیرنده
              </TypoGraphyKit>
            )}
          </StackKit>
        </>
      ) : (
        <>
          <StackKit
            direction={"row"}
            gap={3}
            sx={{ width: "200px" }}
            justifyContent={"center"}
            alignItems={"end"}
          >
            <div
              style={{ cursor: "pointer" }}
              onClick={() => openConfirmationModal("merchant")}
            >
              <StackKit className="overflow-hidden bg-[#2C2B3F] rounded-full p-2 w-[50px] h-[50px] flex items-center justify-center">
                <ProfileMerchant />
              </StackKit>
            </div>

            {data && !data.first_name && isExpanded && (
              <TypoGraphyKit variant="subtitle2" sx={{ minWidth: "130px" }}>
                پنل پذیرنده
              </TypoGraphyKit>
            )}
            {data && data.first_name && isExpanded && (
              <TypoGraphyKit variant="subtitle2" sx={{ minWidth: "130px" }}>
                {data?.first_name} {data?.last_name}
              </TypoGraphyKit>
            )}
          </StackKit>
          <StackKit
            direction={"row"}
            gap={2}
            sx={{ width: "300px" }}
            justifyContent={"space-evenly"}
            alignItems={"end"}
          >
            <div
              style={{ cursor: "pointer" }}
              onClick={() => openConfirmationModal("user")}
            >
              <StackKit className="overflow-hidden bg-[#2C2B3F] rounded-full p-1 w-[30px] h-[30px] flex items-center justify-center">
                <AvatarImg />
              </StackKit>
            </div>
            {isExpanded && (
              <TypoGraphyKit variant="subtitle2" sx={{ minWidth: "100px" }}>
                رفتن به پنل کاربر
              </TypoGraphyKit>
            )}
          </StackKit>
        </>
      )}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        sx={{
          background:
            "linear-gradient(116.85deg, rgba(0, 0, 0, 0.5) -13.97%, rgba(53, 53, 53, 0.4) 52.48%, rgba(0, 0, 0, 0.2) 111.15%)",
        }}
      >
        <DialogTitle
          sx={{
            background:
              "linear-gradient(90deg, #444444 -35.13%, #000000 126.71%)",
          }}
        >
          تغییر نقش کاربری
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
          <DialogContent sx={{background:"linear-gradient(90deg, #444444 -35.13%, #000000 126.71%)",color: "#fff",}}>
            <TypoGraphyKit sx={{width:'100%'}}>
              آیا مطمئن هستید که می‌خواهید نقش خود را به
              <p style={{ display: "inline", margin: "0 4px", fontWeight: "600",width:'100%' }}>
                {pendingRole === "merchant" ? "پذیرنده" : "کاربر عادی"}
              </p>
              تغییر دهید؟
            </TypoGraphyKit>
            <StackKit gap={2} alignItems={"center"} justifyContent={"center"} sx={{ mt: 2 }}>
              <TextField
                {...register("nID")}
                placeholder="نام کاربری"
                sx={{
                  background:"linear-gradient(90deg, #444444 -35.13%, #000000 126.71%)",
                  borderRadius: "10px",
                  width: "100%",
                  color: "#fff",
                  "& .MuiInputBase-input": {
                    color: "#fff",
                  },
                }}
              />
              {errors.nID && (
                <StackKit direction={"row"}>
                  <TypoGraphyKit variant="body1" sx={{ color: "red" }}>
                    {errors.nID?.message}
                  </TypoGraphyKit>
                </StackKit>
              )}
              <TextField
                {...register("pass")}
                type="pass"
                placeholder="رمز عبور"
                sx={{
                  background:"linear-gradient(90deg, #444444 -35.13%, #000000 126.71%)",
                  borderRadius: "10px",
                  width: "100%",
                  color: "#fff",
                  "& .MuiInputBase-input": {
                    color: "#fff",
                  },
                }}
              />
              {errors.pass && (
                <StackKit direction={"row"}>
                  <TypoGraphyKit variant="body1" sx={{ color: "red" }}>
                    {errors.pass?.message}
                  </TypoGraphyKit>
                </StackKit>
              )}
            </StackKit>
          </DialogContent>
          <DialogActions
            sx={{
              background:"linear-gradient(90deg, #444444 -35.13%, #000000 126.71%)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap:5
            }}
          >
            <CustomButton
              onClick={() => setOpenModal(false)}
              sx={{
                background: theme.palette.background.paper,
                ":hover": {color: "#fff",},
                width: "50%",
              }}
            >
              انصراف
            </CustomButton>
            <CustomButton
              type="submit"
              sx={{
                background: theme.palette.primary.main,
                width: "50%",
              }}
            >
              {isPending ? (
                <CircularProgress
                  sx={{ color: "#fff", height: "40px" }}
                  size={24}
                />
              ) : (
                <TypoGraphyKit variant="body1">ورود</TypoGraphyKit>
              )}
            </CustomButton>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default AvatarUploader;
